import defaultColor from "@/components/color";
import cpt_chart_column_option from '@/components/echarts/attrs/cpt-chart-column-option'

let op = JSON.parse(JSON.stringify(cpt_chart_column_option))
const dataText = JSON.stringify([
    {name:'Mon',value:120},
    {name:'Tue',value:200},
    {name:'Wed',value:150},
    {name:'Thu',value:80},
    {name:'Fri',value:70},
    {name:'Sat',value:110}
])

export default {
    attribute:{
        color:defaultColor,
        direction:'x',
        title: {
            text: '',
            //subtext: '纯属虚构',
            left: 'center',
            top: 'top',
            textStyle:{
                fontSize:18,
                color: '#ccc'
            },
            subtextStyle: { fontSize: 12, color: '#aaa' }
        },
        xAxis: {
            show: true,
            name: '',
            axisLabel:{
                show: true,
                color: op.attribute.xAxis.axisLine.lineStyle.color,
                fontSize:13,
                rotate:0//倾斜角度-180~180
            },
            axisLine:{
                show: false,
                lineStyle: {
                    color: '#eee'
                }
            },
            axisTick:{//x轴刻度线
                show: false
            },
            splitLine: {//网格线
                show: false
            }
        },
        yAxis: {
            show: false,
            name: '纵',
            type: 'value',
            axisLabel:{
                show: true,
                color: '#eee',
                fontSize: 13
            },
            axisLine:{
                show: true,
                lineStyle:{
                    color: '#eee'
                }
            },
            axisTick:{//y轴刻度线
                show: true
            },
            splitLine: {//网格线
                show: false
            }
        },
        legend: {
            show: false
        },
        grid:{
            x:10,y:30,x2:30,y2:30,containLabel: true
        },
        series:{
            label: {
                show: false, //数值
                position: 'top',
                color: '#ddd',
                fontSize: 13
            },
            barWidth:18
        },
        tooltip: op.attribute.tooltip,
        dataZoom: {show: false,height:15},
        cptTableData: [{ "name": "维度", "value": "", "namekey": "name" },{ "name": "指标", "value": "", "namekey": "value" }]
    },
    cptDataForm:{
        dataText:dataText, dataSource: 1, pollTime: 0
    },
}
